import { render, staticRenderFns } from "./CopyStakeStreamerFraudReportsTable.vue?vue&type=template&id=cb76b44a&lang=pug"
import script from "./CopyStakeStreamerFraudReportsTable.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStreamerFraudReportsTable.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStreamerFraudReportsTable.vue?vue&type=style&index=0&id=cb76b44a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VMenu,VTextField})
